/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/**
 * Regular expressions to validate phone number.
 */
export abstract class PhoneRegex {

    public static readonly defaultRegex = '^$|^[- +()]*[0-9][- +()0-9]*$';
}
